export default {
  getPage: {
    url: '/replenishmentRestrictions/page',
    method: 'post',
    desc: '补货限制分页'
  },
  inventoryInfo: {
    url: '/replenishmentRestrictions/inventoryInfo',
    method: 'post',
    desc: '补货限制库存绩效'
  },
  addTask: {
    url: '/replenishmentRestrictions/addTask',
    method: 'post',
    desc: '补货限制任务创建'
  },
}
